// Approximate rendered size of a full text button (width="110px") plus the
// HStack spacing={2} gap between them, used to decide whether the full row
// of buttons fits the space currently available.
const FULL_BUTTON_WIDTH = 110;
const GAP = 8;

export const BUTTON_GROUP_MENU_MIN_WIDTH = 160;

/** Width (px) needed to show every button uncollapsed, given a count. */
export const getButtonGroupFullWidth = (count) =>
    count * FULL_BUTTON_WIDTH + (count - 1) * GAP;
